import {Language} from "./Language";
import {Locale} from "@js-joda/locale_en";

export const LangEnglish: Language = {
	key: "en-US",
	locale: Locale.ENGLISH,
	// translations: {
	// 	"accountMenu:button:label": "User",
	// 	"accountMenu:option:login": "Login",
	// 	"accountMenu:option:logout": "Logout",
	// 	"accountMenu:option:settings": "Settings",
	// 	"adnres:v1": "Accepted",
	// 	"adnres:v2": "Rejected",
	// 	"adnres:v3": "In Review",
	// 	"dynamicforms:questions:overview:grid:header:clientName": "Client Name",
	// 	"dynamicforms:questions:overview:grid:header:definition": "Definition",
	// 	"dynamicforms:questions:overview:grid:header:frontEndName": "Frontend Name",
	// 	"dynamicforms:questions:overview:grid:header:lastModifiedBy": "Last Modified By",
	// 	"dynamicforms:questions:overview:grid:header:lastModifiedDateTime": "Last Modified At",
	// 	"dynamicforms:questions:overview:grid:header:creationDateTime": "Created At",
	// 	"dynamicforms:questions:overview:grid:header:link": "Link",
	// 	"dynamicforms:editor:label:fullId": "Full ID",
	// 	"dynamicforms:editor:label:definition": "Definition",
	// 	"dynamicforms:editor:label:frontEndName": "Frontend Name",
	// 	"dynamicforms:editor:label:clientName": "Client Name",
	// 	"dynamicforms:editor:label:parameters": "Parameters",
	// 	"dynamicforms:editor:label:extends": "Extends",
	// 	"dynamicforms:editor:label:name": "Name",
	// 	"dynamicforms:editor:label:label": "Label",
	// 	"dynamicforms:editor:label:description": "Description",
	// 	"dynamicforms:editor:label:valueType": "Value Type",
	// 	"dynamicforms:editor:label:queryType": "Query Value",
	// 	"dynamicforms:editor:label:valueOptions": "Value Options (value-display)",
	// 	"dynamicforms:editor:label:unit": "Unit Type",
	// 	"dynamicforms:editor:label:defaultValue": "Default Value",
	// 	"dynamicforms:editor:label:mapping": "Mapping",
	// 	"dynamicforms:editor:label:defaultPositioning": "Default Positioning",
	// 	"dynamicforms:editor:label:missingRequiredValueErrorMessage": "Missing Required Value Message",
	// 	"dynamicforms:editor:label:valueMapping": "Value Mapping",
	// 	"dynamicforms:editor:label:defaultValueExpression": "Default Value Expression",
	// 	"dynamicforms:editor:label:labelExpression": "Label Expression",
	// 	"dynamicforms:editor:label:visibleExpression": "Visible Expression",
	// 	"dynamicforms:editor:label:enabledExpression": "Enabled Expression",
	// 	"dynamicforms:editor:label:editableExpression": "Editable Expression",
	// 	"dynamicforms:editor:label:requiredExpression": "Required Expression",
	// 	"dynamicforms:editor:label:validators": "Validators",
	// 	"dynamicforms:editor:label:custom": "Custom Properties",
	// 	"dynamicforms:editor:label:formName": "Form Name",
	// 	"dynamicforms:editor:label:clientId": "Client Name",
	// 	"dynamicforms:editor:label:remoteFormsNames": "Remote Forms Names",
	// 	"dynamicforms:editor:label:layout": "Layout",
	// 	"dynamicforms:editor:label:questions": "Questions",
	// 	"entityState:active": "Active",
	// 	"entityState:deleted": "Deleted",
	// 	"language:name:en-gb": "English",
	// 	"language:name:nld": "Dutch",
	// 	"orderStatus:queued": "Queued",
	// 	"orderStatus:processing": "Processing",
	// 	"orderStatus:queuedForSaving": "Saving",
	// 	"orderStatus:underReview": "Under Review",
	// 	"orderStatus:error": "Error",
	// 	"orderStatus:done": "Completed",
	// 	"orders:overview:grid:header:address": "Address",
	// 	"orders:overview:grid:header:email": "Email",
	// 	"orders:overview:grid:header:clientName": "Client Name",
	// 	"orders:overview:grid:header:processReference": "Process reference",
	// 	"orders:overview:grid:header:link": "Link",
	// 	"orders:overview:grid:header:orderId": "Order ID",
	// 	"orders:overview:grid:header:orderType": "Order Type",
	// 	"orders:overview:grid:header:policyId": "Policy ID",
	// 	"orders:overview:grid:header:productCategory": "Product Category",
	// 	"orders:overview:grid:header:productDescription": "Product Description",
	// 	"orders:overview:grid:header:status": "Order Status",
	// 	"orders:overview:grid:header:surname": "Surname",
	// 	"orders:overview:grid:header:transactionDate": "Date",
	// 	"orders:overview:grid:header:underwritingResult": "Financial Status",
	// 	"productIncentiveType:hello_fresh_coupon": "Hello Fresh Coupon",
	// 	"products:products:overview:grid:header:clientName": "Client Name",
	// 	"products:products:overview:grid:header:externalId": "External ID",
	// 	"products:products:overview:grid:header:dataProviderKrn": "Data Provider KRN",
	// 	"products:products:overview:grid:header:description": "Description",
	// 	"products:products:overview:grid:header:productSupplierKrn": "Product Supplier KRN",
	// 	"products:products:overview:grid:header:productType": "Product Type",
	// 	"products:products:overview:grid:header:productTypeKrn": "Product Type KRN",
	// 	"products:products:overview:grid:header:orderType": "Order Type",
	// 	"products:products:overview:grid:header:productCategory": "Product Category",
	// 	"products:products:overview:grid:header:affiliateUrl": "Affiliate URL",
	// 	"products:products:overview:grid:header:insuranceCardUrl": "Insurance Card URL",
	// 	"products:products:overview:grid:header:termsAndConditionsUrl": "Terms and Conditions URL",
	// 	"products:products:overview:grid:header:supplierGenericProduct": "Is Generic Product",
	// 	"products:suppliers:overview:grid:header:link": "Link",
	// 	"products:suppliers:overview:grid:header:krn": "KRN",
	// 	"products:suppliers:overview:grid:header:name": "Name",
	// 	"products:suppliers:overview:grid:header:legalName": "Legal Name",
	// 	"products:suppliers:overview:grid:header:clientName": "Client Name",
	// 	"products:suppliers:overview:grid:header:productIncentiveType": "Incentive Type",
	// 	"products:suppliers:overview:grid:header:comparatorId": "Comparator ID",
	// 	"products:suppliers:overview:grid:header:lastModifiedBy": "Last Modified By",
	// 	"products:suppliers:overview:grid:header:lastModifiedDateTime": "Last Modified At",
	// 	"products:suppliers:overview:grid:header:state": "Status",
	// 	"productStatus:active": "Active",
	// 	"productStatus:deleted": "Deleted",
	// 	"productSupplierStatus:active": "Active",
	// 	"productSupplierStatus:deleted": "Deleted",
	// 	"productSupplierStatus:hidden": "Hidden",
	// 	"productSupplierStatus:inactive": "Inactive",
	// 	"productOrderType:affiliate": "Affiliate",
	// 	"productOrderType:funnel_mga": "Funnel MGA",
	// 	"productOrderType:not_orderable": "Not Orderable",
	// 	"productCategory:non_specific": "Non Specific",
	// 	"productCategory:car": "Car",
	// 	"productCategory:energy": "Energy",
	// 	"productCategory:home": "Home",
	// 	"productCategory:liability": "Liability",
	// 	"productCategory:triple_play": "Triple Play",
	// 	"productCategory:travel": "Travel",
	// 	"productCategory:health_care": "Health Care",
	// 	"productCategory:funeral": "Funeral",
	// 	"productCategory:loan": "Loan",
	// 	"productCategory:sim_only": "Sim-Only",
	// 	"productCategory:animal": "Animal",
	// 	"productCategory:bike": "Bike",
	// 	"sidebar:buildInfo:built": "Built:",
	// 	"sidebar:buildInfo:version": "Version:",
	// 	"unauthorized:header": "Not Authorized",
	// 	"unauthorized:logged-on": "You do not have enough permissions to view this page.\nIf your permissions recently changed, try loggin in again to update your permissions.",
	// 	"unauthorized:no-user": "You have to be logged on to view this page, please log in and try again.",
	// 	"userSettings:header": "Settings",
	// 	"userSettings:setting:language:label": "Language",
	// 	"userSettings:setting:colorTheme:label": "Color Theme",
	// 	"userSettings:setting:colorTheme:options:label:none": "No preference",
	// 	"userSettings:setting:colorTheme:options:label:light": "Light",
	// 	"userSettings:setting:colorTheme:options:label:dark": "Dark",
	// 	"userSettings:setting:colorTheme:options:label:systemDefault": "System default",
	// 	"unknown": "Unknown",
	// }
};
